import {Observable} from 'rxjs';
import {inject, Injectable} from '@angular/core';
import {Organization} from './organization.types';
import {ApiService} from '@aviary/services/api.service';

@Injectable({providedIn: 'root'})
export class OrganizationService {

  private readonly apiService: ApiService = inject(ApiService);

  public loadAuthOrganization(): Observable<Organization> {
    const endpoint: string = 'public/v1/organizations/tenant/patron-ui';

    return this.apiService.get(endpoint);
  }
}
